import React from "react";
//import Table from "./Table";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faSearch,
  faChevronCircleDown,
  faCheck,
  faCheckCircle,
  faExclamationTriangle,
  faTimesCircle,
  faFileSignature,
  faSearchPlus,
} from "@fortawesome/free-solid-svg-icons";
// import styles from "../../master.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link, useHistory } from "react-router-dom";
import LeaseListingTable from "./LeaseListingTable";
import ProspectListingTable from './ProspectListingTable';
import { DropdownButton, Dropdown } from "react-bootstrap";
import "bootstrap";

import { hasAccess } from "../../utils/index";
import Prospect from "../prospect/Prospect";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class LeaseListing extends React.Component {
  state = {
    showProspect: false,
    isDropped: false,
    redirect: false,
    brands: [],
    assets: [],
    statusCount: {},
    selectedBrand: "",
    selectedAsset: "",
    selectedStatus: 2,
    randomNum: "",
    activeIndex: null,
    state: ""
  };

  constructor(props) {
    super(props);
    this.goToCreateLease = this.goToCreateLease.bind(this);
    this.goToProspect = this.goToProspect.bind(this);

    //let match = useRouteMatch();
console.log(props,"props")
    if (!hasAccess(["admin"])) {
      console.log("calingg");
      let path = `/lease-summary`;
      this.props.history.push(path);
    }
  }

  componentDidMount() {
    this.loadBrands();
    this.loadAssets();

    fetch(`${apiUrl.apiUrl.url}/lease-view/get-status-count`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          statusCount: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
      this.loadLeaseCountStatuswise();
  }

  loadLeaseCountStatuswise = (brand,asset) =>  {
    console.log(asset, "asset");
    // this.setState({});
     var brandId = typeof brand != "undefined" ? brand : this.state.selectedBrand;
     var assetId = typeof asset != "undefined" ? asset : this.state.selectedAsset;
     var ths = this;
     fetch(
       `${apiUrl.apiUrl.url}/lease-view/get-status-count?brand=` +
       brandId +
         `&stateId=${this.state.state}&asset=${assetId}`, {headers}
     )
       .then((response) => {
         return response.json();
       })
       .then((data) => {
         ths.setState({
           statusCount: data,
         });
       })
       .catch((error) => {
         console.log(error);
       });
     this.setState({});
   }


  loadAssets = async () => {
    const response = await axios.get(`${apiUrl.apiUrl.url}/assets`);
    console.log(response);
    this.state.assets = response.data;
    this.setState({});
  };

  loadBrands = async () => {
    const response = await axios.get(
      `${apiUrl.apiUrl.url}/brand/get-brands?page=1&per_page=100&delay=1`
    );
    this.state.brands = response.data.data;
    this.setState({});
  };
  goToCreateLease = () => {
    let path = `/${this.props.match.path}/lease-landlord`;
    this.props.history.push(path);
  };
  goToProspect = () => {
    let path = `/${this.props.match.path}/prospect`;
    this.props.history.push(path);
  };
  render() {
    return (
      <div
        className="parentContainer"
        style={{
          float: "left",
          width: "100%",
          display: "block",
          overflowY: "auto",
          overflowX: "hidden",
          height: "100%",
          padding: "25px",
        }}
      >
        <div>
          {this.renderForm()}
        </div>
      </div>
    );
  }

  renderForm() {
    return (
      <div className="viewLeaseSection">
        <div className="unitFormContainer viewLeaseForm">
          <div className="container">
            <div className="row">
              <div className="col-lg-3">
                <Link
                  to={`${this.props.match.path}/lease-landlord`}
                  className="listingFormButton"
                >
                  Create Lease
                </Link>
              </div>
              <div className="col-lg-3">
                <Link to={`${this.props.match.path}/prospect`} className="listingFormButton">
                  <FontAwesomeIcon icon={faSearchPlus} /> Prospect
                </Link>
              </div>
              <div className="col-lg-3">
                <div className="inputContainer">
                  <select
                    onChange={(e) => {
                      this.setState({
                        selectedAsset: e.target.value,
                        randomNum: Math.random(),
                      });
                      this.loadLeaseCountStatuswise( this.state.selectedBrand , e.target.value);
                    }}
                  >
                    <option value="">Select Asset</option>
                    {this.state.assets.map((x) => (
                      <option key={x.id} value={x.id}>
                        {x.asset_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="inputContainer">
                  <select
                    onChange={(e) => {
                      this.setState({
                        selectedBrand: e.target.value,
                        randomNum: Math.random(),
                      });

                      this.loadLeaseCountStatuswise( e.target.value , this.state.selectedAsset)

                    }}
                  >
                    <option value="">Select Brand</option>
                    {this.state.brands.map((x) => (
                      <option key={x.brandId} value={x.brandId}>
                        {x.brandName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="container cards">
            <div className="row">
              <div
                className={
                  this.state.selectedStatus === 5
                    ? "col isActive mb-4"
                    : "col mb-4"
                }
                onClick={(e) => {
                  //this.setState({ selectedAsset: e.target.value });

                  // this.setState({
                  //   selectedStatus: 5,
                  //   randomNum: Math.random(),
                  // });
                  this.setState({
                    selectedStatus: 5,
                    randomNum: Math.random(),
                    showProspect:  true,
                    isDropped: false
                  })
                  

                }}
              >
                <div className="viewLeaseCards">
                  <div className="row m-0">
                    <div className="col-12">
                      <span className="iconHolder">
                        <FontAwesomeIcon icon={faSearch} />
                      </span>
                    </div>
                    <div className="col-12">
                      <h2>{this.state.statusCount.prospect}</h2>
                    </div>
                    <div className="col-12">
                      <h1>Draft Prospect </h1>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  this.state.selectedStatus === 6
                    ? "col mb-4 isActive"
                    : "col mb-4"
                }
                onClick={(e) => {
                  //this.setState({ selectedAsset: e.target.value });
                  this.setState({
                    selectedStatus: 6,
                    randomNum: Math.random(),
                    showProspect: true,
                    isDropped: true
                  });
                }}
              >
                <div className="viewLeaseCards">
                  <div className="row m-0">
                    <div className="col-12">
                      <span className="iconHolder">
                        <FontAwesomeIcon icon={faChevronCircleDown} />
                      </span>
                    </div>
                    <div className="col-12">
                      <h2>{this.state.statusCount.dropped}</h2>
                    </div>
                    <div className="col-12">
                      <h1>Final Prospect </h1>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  this.state.selectedStatus === 0
                    ? "col mb-4 isActive"
                    : "col mb-4"
                }
                onClick={(e) => {
                  //this.setState({ selectedAsset: e.target.value });
                  this.setState({
                    selectedStatus: 0,
                    randomNum: Math.random()                   
                  });
                }}
              >
                <div className="viewLeaseCards">
                  <div className="row m-0">
                    <div className="col-12">
                      <span className="iconHolder">
                        <FontAwesomeIcon icon={faFileSignature} />
                      </span>
                    </div>
                    <div className="col-12">
                      <h2>{this.state.statusCount.draft}</h2>
                    </div>
                    <div className="col-12">
                      <h1>Draft </h1>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  this.state.selectedStatus === 1
                    ? "col mb-4 isActive"
                    : "col mb-4"
                }
                onClick={(e) => {
                  //this.setState({ selectedAsset: e.target.value });
                  this.setState({
                    selectedStatus: 1,
                    randomNum: Math.random(),
                  });
                }}
              >
                <div className="viewLeaseCards">
                  <div className="row m-0">
                    <div className="col-12">
                      <span className="iconHolder">
                        <FontAwesomeIcon icon={faCheck} />
                      </span>
                    </div>
                    <div className="col-12">
                      <h2>{this.state.statusCount.approval}</h2>
                    </div>
                    <div className="col-12">
                      <h1>Approval</h1>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  this.state.selectedStatus === 2
                    ? "col mb-4 isActive"
                    : "col mb-4"
                }
                onClick={(e) => {
                  //this.setState({ selectedAsset: e.target.value });
                  this.setState({
                    selectedStatus: 2,
                    randomNum: Math.random(),
                    showProspect: false
                  });
                }}
              >
                <div className="viewLeaseCards">
                  <div className="row m-0">
                    <div className="col-12">
                      <span className="iconHolder">
                        <FontAwesomeIcon icon={faCheckCircle} />
                      </span>
                    </div>
                    <div className="col-12">
                      <h2>{this.state.statusCount.active}</h2>
                    </div>
                    <div className="col-12">
                      <h1>Active</h1>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  this.state.selectedStatus === 3
                    ? "col mb-4 isActive"
                    : "col mb-4"
                }
                onClick={(e) => {
                  //this.setState({ selectedAsset: e.target.value });
                  this.setState({
                    selectedStatus: 3,
                    randomNum: Math.random(),
                    showProspect: false
                  });
                }}
              >
                <div className="viewLeaseCards">
                  <div className="row m-0">
                    <div className="col-12">
                      <span className="iconHolder">
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                      </span>
                    </div>
                    <div className="col-12">
                      <h2>{this.state.statusCount.expired}</h2>
                    </div>
                    <div className="col-12">
                      <h1>Expired</h1>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  this.state.selectedStatus === 4
                    ? "col mb-4 isActive"
                    : "col mb-4"
                }
                onClick={(e) => {
                  //this.setState({ selectedAsset: e.target.value });
                  this.setState({
                    selectedStatus: 4,
                    randomNum: Math.random(),
                    showProspect: false
                  });
                }}
              >
                <div className="viewLeaseCards">
                  <div className="row m-0">
                    <div className="col-12">
                      <span className="iconHolder">
                        <FontAwesomeIcon icon={faTimesCircle} />
                      </span>
                    </div>
                    <div className="col-12">
                      <h2>{this.state.statusCount.terminated}</h2>
                    </div>
                    <div className="col-12">
                      <h1>Terminated</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        { this.state.showProspect ?     <ProspectListingTable
          key={this.state.randomNum}
          isDropped={this.state.isDropped}
          asset={this.state.selectedAsset}
          brand={this.state.selectedBrand}
          status={this.state.selectedStatus}
         
        /> :     
        <LeaseListingTable
          key={this.state.randomNum}
          asset={this.state.selectedAsset}
          brand={this.state.selectedBrand}
          status={this.state.selectedStatus}
        />
        }
      </div>
    );
  }
}

export default withRouter(LeaseListing);
